import React, { useContext, useEffect, useMemo, useReducer } from 'react'
import { actions } from '../actions/assignments';
import { CONFIG, DELEGATIONS_ASSIGNATIONS } from '../config';
import { useFetch } from '../services/fetch';
import { errorMessageQueryMenuAssignations } from '../utils/variables';
import { useCognitoProvider } from './CognitoContext';
import { useErrorProvider } from './ErrorProvider';

const initialState = {
    assignments: []
}

const AssignmentsContext = React.createContext({
    state: null,
    dispatch: null,
});

function reducer(state, action) {
    switch (action.type) {
        case actions.FETCH:
            return { assignments: action.payload }
        default:
            return state;
    }
}

export default function AssignmentsProvider({ children }) {

    const [state, dispatch] = useReducer(reducer, initialState);
    const {interceptedFetch} = useFetch();
    const { dispatch: errorDispatch } = useErrorProvider();
    const { state: cognitoState } = useCognitoProvider();
    const apiData = CONFIG.api.find(f => f.key === DELEGATIONS_ASSIGNATIONS);
    const headers = { 'Authorization': cognitoState.idToken, 'Content-Type': 'application/json' };

    useEffect(() => { 
        if(cognitoState.pkOperador_b) fetchData();
     }, [cognitoState.pkOperador_b]);

    const fetchData = async () => {
        let data = [];
        try {
            const response = await interceptedFetch(
                `${apiData.endpoint}/${cognitoState.pkOperador_b}`,
                { method: apiData.method, headers }
            );
            if (response.status !== 200) throw errorMessageQueryMenuAssignations; 
            const responseData = await response.json();
            if(responseData.assignments)
                data = responseData.assignments;
        } catch (e) {
            errorDispatch({type: actions.OPEN_MODAL, payload: e});
        } finally {
            dispatch({ type: actions.FETCH, payload: data });
        }
    }

    const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);

    return <AssignmentsContext.Provider value={contextValue}>
        {children}
    </AssignmentsContext.Provider>
}

export const useAssignmentsProvider = () => useContext(AssignmentsContext);